<template>
    <div class="row">
        <div v-if="!maximize" class="col-lg-3">
            <b-card>
                <app-timeline>
                    <app-timeline-item 
                        v-for="(item,i) in items" :key="i" 
                        :time="item.time"
                        :title="item.title"
                        :subtitle="item.subtitle"
                        :icon="getIcon(i)"
                        :title-class="i == current ? `font-weight-bolder text-secondary`: null"
                        :variant="getVariant(i)" />
                </app-timeline>
            </b-card> 
        </div>
        <div :class="!maximize ? 'col-lg-9' : 'col-12'">
            <b-card no-body class="p-1 mb-1">
                <div class="row align-items-center">
                    <div class="col-auto border-right">
                        <button class="btn btn-outline-dark btn-icon" v-b-tooltip.bottom.hover="!maximize ? 'Genişlet' : 'Daralt'" v-on:click="maximize = !maximize">
                            <feather-icon v-if="!maximize" icon="MaximizeIcon"></feather-icon>
                            <feather-icon v-else icon="MinimizeIcon"></feather-icon>
                        </button>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.month" :disabled="current > 0">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="donem.year" :disabled="current > 0">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col-md-5 mb-1 mb-md-0">
                        <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" :disabled="current > 0" placeholder="Tüm Maaş Grupları"></v-select-list>
                    </div>
                </div>
            </b-card>

            <template v-if="current == 0">
                <g-calculate-salary-process-get-excel 
                    :donem="donem"
                    :filter="filter"
                    v-on:next="next(1)">
                </g-calculate-salary-process-get-excel>
            </template>
            <template v-if="current == 1">
                <g-calculate-salary-process-upload-excel 
                    :donem="donem"
                    :filter="filter"
                    v-on:next="next(2)"
                    v-on:back="next(0)">
                </g-calculate-salary-process-upload-excel>
            </template>
            <template v-if="current == 2">
                <g-calculate-salary-process-approve-lock
                    :donem="donem"
                    :filter="filter"
                    v-on:next="next(3)"
                    v-on:back="next(1)">
                </g-calculate-salary-process-approve-lock>
            </template>
            <template v-if="current == 3">
                <g-calculate-salary-process-ticket-excel
                :donem="donem"
                    :filter="filter"
                    v-on:next="next(4)"
                    v-on:back="next(2)">
                </g-calculate-salary-process-ticket-excel>
            </template>
            <template v-if="current == 4">
                <g-calculate-salary-process-upload-bordro
                :donem="donem"
                    :filter="filter"
                    v-on:back="next(3)">
                </g-calculate-salary-process-upload-bordro>
            </template>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { BCard, VBTooltip } from 'bootstrap-vue';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import GCalculateSalaryProcessGetExcel from './components/GCalculateSalaryProcessGetExcel.vue';
import GCalculateSalaryProcessUploadExcel from './components/GCalculateSalaryProcessUploadExcel.vue';
import GCalculateSalaryProcessApproveLock from './components/GCalculateSalaryProcessApproveLock.vue';
import GCalculateSalaryProcessUploadBordro from './components/GCalculateSalaryProcessUploadBordro.vue';
import GCalculateSalaryProcessTicketExcel from './components/GCalculateSalaryProcessTicketExcel.vue';
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    components:{
        AppTimeline,
        AppTimelineItem,
        BCard,
        GCalculateSalaryProcessGetExcel,
        GCalculateSalaryProcessUploadExcel,
        GCalculateSalaryProcessApproveLock,
        GCalculateSalaryProcessUploadBordro,
        GCalculateSalaryProcessTicketExcel
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return {
            current:0,
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            maximize:false,
            items:[
                {time:'1',title:'Şablon Oluşturma',subtitle:'Personellerin maaş parametrelerini içeren Excel çıktısını oluşturun ve indirin.'},
                {time:'2',title:'Yükleme ve Düzenleme',subtitle:'Gerekli kolonlarını doldurduğunuz Excel çıktısını yükleyin ve yüklediğiniz bilgileri düzenleyin.'},
                {time:'3',title:'Onaylama & Kilitleme',subtitle:'Düzenlemesini tamamladığınız personellerin bilgilerini onaylayın. Tüm düzenlemelerin tamamlandığından emin olduğunuzda maaş verisinin tamamlanması için ilgili verileri kilitleyin.'},
                {time:'4',title:'Ticket Ödeme Şablonu',subtitle:'Onaylanmış ve kilitlenmiş maaşlar için ticket ödeme tablosu üretin ve indirin.'},
                {time:'5',title:'Bordro Yükleme',subtitle:'Onaylanan ve kilitlenen maaşların bir sonraki adıma geçilebilmesi için bordro yüklemelerini yapın.'},
            ],
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            employeeSalaryGroups:[],
            employeeSalaryGroupId:null
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses(),
        this.getEmployeeSalaryGroups()
    },
    methods:{
        getIcon(i){
            if(this.current == i){
                return 'ArrowRightCircleIcon'
            } else if(this.current > i){
                return 'CheckCircleIcon'
            } else return 'AlertOctagonIcon'
        },
        getVariant(i){
            if(this.current == i){
                return 'secondary'
            } else if(this.current > i){
                return 'success'
            } else return 'dark'
        },
        next(i){
            this.current = i
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        back(i){
            this.current = i
            window.scrollTo({top: 0, behavior: 'smooth'})
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        getEmployeeSalaryGroups(){
            EmployeeOperationsApi.SalaryGroup.List().then(res=>{
                this.employeeSalaryGroups = res.data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
    },
    computed:{
        filter(){
            return {
                EmployeeSalaryGroupId:this.employeeSalaryGroupId?.Key||null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>

<style>
.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}

.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103) !important;
}
</style>